import styled from 'astroturf/react'
import { BareButton } from '@calendly/ui/components/bare-button'
import { ArrowChevronLeftMiniIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'

import { useI18n } from 'locales'
import _Root from "booking_redesign_back_link-Root.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/booking_redesign_back_link.js?styleId=Root";


const Root = /*#__PURE__*/styled(BareButton, null, {
  displayName: "Root",
  styles: _Root
})

export const BookingRedesignBackLink = ({ onClick, href, className }) => {
  const { i18n } = useI18n()

  return (
    <Root
      as={href ? 'a' : undefined}
      href={href}
      type={href ? undefined : 'button'}
      onClick={href ? undefined : onClick}
      className={className}
    >
      <ArrowChevronLeftMiniIcon aria-hidden />
      <BodyText as="span" inline size="medium" weight="bold" color={primaryColor}>
        {i18n.t('booking.action.back')}
      </BodyText>
    </Root>
  )
}
